import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <span className="font-heading text-xl font-bold whitespace-nowrap">
              Kakobuy<span className="text-accent-400">Spreadsheet</span>
            </span>
            <p className="text-sm text-white/60 mt-3 leading-relaxed max-w-xs">
              Największa polska baza produktów Kakobuy. Znajdź najlepsze produkty z Chin – szybko, bezpiecznie i wygodnie.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4">Szybkie linki</h4>
            <div className="space-y-2">
              <a href="#czym-jest" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">Czym jest Kakobuy Spreadsheet?</a>
              <a href="#kategorie" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">Kategorie produktów</a>
              <a href="#bezpieczenstwo" className="block text-sm text-white/60 hover:text-white transition-colors cursor-pointer">Bezpieczeństwo</a>
              <Link to="/artykul/czym-jest-kakobuy-spreadsheet" className="block text-sm text-white/60 hover:text-white transition-colors">Artykuły</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4">Przejdź do arkusza</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-accent-500 hover:bg-accent-600 text-white font-medium rounded-full text-sm transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-external-link-line"></i> Kakobuy Spreadsheet
            </a>
            <p className="text-xs text-white/40 mt-4">
              © 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}